<div class="bp-selector" (click)="$event.stopPropagation()">
  <div class="trigger" (click)="toggleOpen()">
    <div class="label">
      <span class="selected" *ngIf="selected">{{ selected.CompanyName || selected.Name }}</span>
      <span class="placeholder" *ngIf="!selected">{{ placeholder | translate }}</span>
    </div>
    <span class="chevron" aria-hidden="true"></span>
    <div class="level" *ngIf="showLevelFilter" (click)="$event.stopPropagation()">
      <button class="level-trigger" type="button" (click)="toggleLevelOpen($event)">
        {{ selectedLevel === 'ALL' ? ('business_partners.level_all' | translate) : selectedLevel }}
      </button>
      <div class="level-panel" *ngIf="openLevel">
        <div class="level-item" [class.active]="selectedLevel === 'ALL'" (click)="onSelectLevel('ALL', $event)">{{ 'business_partners.level_all' | translate }}</div>
        <div class="level-item" *ngFor="let lvl of levels" [class.active]="selectedLevel === lvl" (click)="onSelectLevel(lvl, $event)">{{ lvl }}</div>
      </div>
    </div>
  </div>

  <div class="panel" *ngIf="open">
    <div class="search">
      <span class="icon" aria-hidden="true"></span>
      <input type="text" [ngModel]="searchTerm" (ngModelChange)="onSearchChange($event)" [placeholder]="'bp_selector.search' | translate" />
      <button class="clear" *ngIf="searchTerm" (click)="clearSearch()" type="button" aria-label="Clear search" title="Clear search">&times;</button>
    </div>
    <ul class="list">
      <li class="item" *ngFor="let p of filteredPartners" (click)="selectPartner(p)">
        <div class="name">{{ p.CompanyName || p.Name }}</div>
        <div class="meta">
          <span class="bp-level">L{{ p.Level }}</span>
        </div>
      </li>
      <li class="empty" *ngIf="filteredPartners.length === 0">{{ 'bp_selector.no_results' | translate }}</li>
    </ul>
  </div>
</div>


